module.exports = __webpack_public_path__ + "static/img/bg_4.a534048a.png";